/*
*  Computed prop to check does browser match minimum of required features
*/

export default {
    computed: {
        canStart() {
            const m = window.Modernizr;
            return m && m.webgl && m.webworkers && m.webglextensions
        }
    },
}